import { IFInitWalletWithdrawFlatRsp } from "@/api/apiRsp/IFWalletRsp";
import SelectUI, { SelectOption, SelectUIProps } from "@/componentsUI/Select";
import React from "react";
const Option = SelectOption;
import "./index.less";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";

export interface WidthdrawProps extends SelectUIProps {
  configs: IFInitWalletWithdrawFlatRsp[];
  onChange?: any;
  value?: any;
}

const WidthdrawWay = (props: WidthdrawProps) => {
  const { configs, value, onChange } = props;
  const { t } = useTranslationPlus();

  function handleChange(withdrawType: number) {
    const index = configs?.findIndex((element) => {
      if (element.withdrawType === withdrawType) {
        return true;
      }
    });
    const item = configs?.[index] || {};
    onChange &&
      onChange({
        type: withdrawType,
        data: item,
      });
  }

  return (
    <div className="widthdraw-way">
      <SelectUI
        value={value?.type}
        onChange={handleChange}
      >
        {configs?.map((option: IFInitWalletWithdrawFlatRsp, index) => (
          <Option key={index} value={option?.withdrawType} className={`option`}>
            <span> {t(`Wallet.Withdraw_${option.withdrawType}`)}</span>
          </Option>
        ))}
      </SelectUI>
    </div>
  );
};

export default WidthdrawWay;
